import { jsx as _jsx } from "react/jsx-runtime";
const errorStyle = {
    color: 'red',
    position: 'fixed',
    top: '0',
    left: '0'
};
function ErrorBubble(props = { message: '' }) {
    const style = { ...errorStyle, display: props.message ? 'block' : 'none' };
    return _jsx("div", { style: style, children: `Something went wrong: ${props.message}` });
}
export default ErrorBubble;
